import { OpenTabsCounter } from './utils';

export * from './index';
OpenTabsCounter.init();
